module.exports = __webpack_public_path__ + "606f45e1cd94de2eb288391848a47eea.woff";